/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import classnames from "classnames";
import marked from "marked";
import { Trans } from "react-i18next";
import styles from "./DocumentNavigator.module.scss";
import { FlexGrid, WithPropsGuard } from "../../../_common";
import Scrollspy from "react-scrollspy";

interface Props {
  headings: marked.Tokens.Heading[];
  headerPrefix: string;
  className?: string;
}

interface State {}

export const SECTION_HEADING_TEXT_NUMBER_AND_DASH_FILTER = /[^a-z0-9\-_ ]/g;
export const SECTION_HEADING_SPACE_FILTER = / /g;

class DocumentNavigator extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      headings: null,
      error: false,
    };
  }

  renderNavigation() {
    const { headings, headerPrefix } = this.props;

    const transformHeadingTextToSectionKey = (text: string) =>
      `${headerPrefix}${text
        .toLowerCase()
        .replace(SECTION_HEADING_TEXT_NUMBER_AND_DASH_FILTER, "")
        .replace(SECTION_HEADING_SPACE_FILTER, "-")}`;

    return (
      <div className={styles.list}>
        <Scrollspy
          items={headings.map((heading) => transformHeadingTextToSectionKey(heading.text))}
          currentClassName={styles.active as string}
        >
          {headings.map((heading: marked.Tokens.Heading, number) => {
            return (
              <li className={styles.item} data-depth={heading.depth} key={`${number}-${heading.text}`}>
                <a href={`#${transformHeadingTextToSectionKey(heading.text)}`}>{heading.text}</a>
              </li>
            );
          })}
        </Scrollspy>
      </div>
    );
  }

  render() {
    const { className } = this.props;
    return (
      <FlexGrid className={classnames(styles.documentNavigator, className)}>
        <div className={styles.stickyContainer}>
          <div className={styles.title}>
            <Trans i18nKey={"Document.navigator.title"}>Contents</Trans>
          </div>
          {this.renderNavigation()}
        </div>
      </FlexGrid>
    );
  }
}

export default WithPropsGuard<Props>(DocumentNavigator, (prevProps, nextProps) => {
  return prevProps.headings.toString() !== nextProps.headings.toString();
});
